export default __webpack_public_path__ + "static/media/logo.8b4bfb91.svg";